<template>
  <div class="dashboard-header col-12" style="padding: 0 6%">
    <div class="col-4" style="padding-left: 1%">
      <div class="avatar" v-if="profilePictureUrl">
        <a v-if="!editable" href="/mon-profil">
          <img :src="profilePictureUrl" width="80" height="80"/>
        </a>
        <div v-else class="avatar-wrapper" @click="triggerFileInput">
          <img :src="profilePictureUrl" width="80" height="80"/>
          <div class="avatar-overlay">Modifier</div>
        </div>
      </div>
      <img v-if="!profilePictureUrl" src="@/assets/img/user-profile-circle.png" width="80" height="80" style="opacity: 0.8; background: rgba(203, 219, 42, 0.3); border-radius: 100%"/>
      <input
          ref="photoInput"
          accept="image/jpeg, image/png"
          class="candidature-input-file"
          type="file"
          style="display: none;"
          @change="handlePhotoSelect"
      >
      <!-- Modal de recadrage -->
      <div v-if="showCropperModal" class="modal-overlay" @click="closeCropper">
        <div class="modal-content" @click.stop>
          <div class="modal-header">
            <h3>Recadrer votre photo de profil</h3>
            <button @click="closeCropper" class="close-btn">×</button>
          </div>
          <div class="modal-body">
            <vue-cropper
                ref="cropper"
                :src="imageSrc"
                :aspect-ratio="1"
                :view-mode="2"
                :auto-crop-area="1"
                :background="false"
                :guides="true"
                :center="true"
                :highlight="true"
                :crop-box-movable="true"
                :crop-box-resizable="true"
                :toggle-drag-mode-on-dblclick="true"
                :rotatable="true"
                :zoomable="false"
                :img-style="{ 'max-width': '400px', 'max-height': '400px' }"
                :initial-aspect-ratio="1"
                :fit="true"
            />
          </div>
          <div class="modal-footer">
            <div class="rotation-controls">
              <button class="btn btn-icon btn-secondary" title="Pivoter à gauche" @click.prevent="rotateLeft">
                <svg class="rotation-icon rotate-left" viewBox="0 0 24 24">
                  <path d="M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z"/>
                </svg>
              </button>
              <button class="btn btn-icon btn-secondary" title="Pivoter à droite" @click.prevent="rotateRight">
                <svg class="rotation-icon" viewBox="0 0 24 24">
                  <path d="M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z"/>
                </svg>
              </button>
            </div>
            <div class="action-controls">
              <button class="btn btn-secondary" @click="closeCropper">Annuler</button>
              <button class="btn btn-primary" @click.prevent="cropImage">Valider</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-8">
      <div class="dashboard-header-title">
        <span v-if="!title">Bonjour <span v-if="firstname">{{ firstname }},</span></span>
        <span v-if="title">{{ title }}</span>
      </div>
      <div class="dashboard-header-subtitle">
        <span v-if="!subtitle">Bienvenue dans votre espace candidat</span>
        <span v-if="subtitle">{{ subtitle }}</span>
      </div>
    </div>
    <div class="col-2 dashboard-header-logo" style="text-align: right">
      <img src="@/assets/img/logo.png" alt="Apform"/>
    </div>
  </div>
</template>

<script>
import VueCropper from 'vue-cropperjs';
import 'cropperjs/dist/cropper.css';

export default {
  name: "DashboardHeader",
  props: {
    firstname: String,
    profilePictureUrl: String,
    title: String,
    subtitle: String,
    editable: {
      type: Boolean,
      default: false
    }
  },
  components: {
    VueCropper
  },
  data() {
    return {
      showCropperModal: false,
      imageSrc: '',
      croppedImageFile: null,
      FILEPHOTO: null
    };
  },
  methods: {
    triggerFileInput() {
      if (this.editable) {
        this.$refs.photoInput.click();
      }
    },
    handlePhotoSelect(event) {
      const file = event.target.files[0];
      if (!file) return;
      const allowedTypes = ['image/jpeg', 'image/png'];
      if (!allowedTypes.includes(file.type)) {
        alert('Le type de fichier n\'est pas autorisé. Utilisez JPEG ou PNG.');
        return;
      }
      if (file.size > (8 * 1000 * 1024)) {
        alert('Le fichier ne doit pas être supérieur à 8Mo');
        return;
      }
      this.FILEPHOTO = [file];
      const reader = new FileReader();
      reader.onload = (e) => {
        this.imageSrc = e.target.result;
        this.showCropperModal = true;
      };
      reader.readAsDataURL(file);
    },
    cropImage() {
      if (!this.$refs.cropper) return;
      this.$refs.cropper.getCroppedCanvas({
        width: 300,
        height: 300,
        imageSmoothingEnabled: true,
        imageSmoothingQuality: 'high',
      }).toBlob((blob) => {
        const fileName = `photo_profile_${Date.now()}.jpg`;
        this.croppedImageFile = new File([blob], fileName, { type: 'image/jpeg' });
        const tempUrl = URL.createObjectURL(blob);
        this.$emit('update-photo', { file: this.croppedImageFile, url: tempUrl });
        this.closeCropper();
      }, 'image/jpeg', 0.9);
    },
    closeCropper() {
      this.showCropperModal = false;
      this.imageSrc = '';
      if (this.$refs.photoInput) {
        this.$refs.photoInput.value = '';
      }
    },
    rotateLeft() {
      if (this.$refs.cropper) {
        this.$refs.cropper.rotate(-90);
      }
    },
    rotateRight() {
      if (this.$refs.cropper) {
        this.$refs.cropper.rotate(90);
      }
    }
  }
};
</script>

<style>
.modal-overlay .cropper-point {
  width: 15px;
  height: 15px;
}
</style>


<style scoped>
.avatar {
  background-color: transparent;
  height: 90px;
  width: 90px;
  border-radius: 100%;
  overflow: hidden;
  border: 5px solid #CBDB2A;
  position: relative;
}

.avatar-wrapper {
  position: relative;
  cursor: pointer;
}

.avatar-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 500;
  opacity: 0;
  transition: opacity 0.3s;
}

.avatar-wrapper:hover .avatar-overlay {
  opacity: 1;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-overlay .modal-content {
  background: white;
  border-radius: 12px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.3);
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow: auto;
}

.modal-overlay .modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 20px;
  border-bottom: 1px solid #e5e5e5;
}

.modal-overlay .modal-header h3 {
  margin: 0;
  font-size: 1.25rem;
  font-weight: 600;
  color: #333;
}

.modal-overlay .close-btn {
  background: none;
  border: none;
  font-size: 24px;
  cursor: pointer;
  color: #666;
  padding: 0;
  width: 30px;
  height: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 50%;
  transition: all 0.2s;
}

.modal-overlay .close-btn:hover {
  background: #f5f5f5;
  color: #333;
}

.modal-overlay .modal-body {
  padding: 20px;
}

.modal-overlay .cropper-container {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 20px;
  text-align: center;
  min-height: 300px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay .modal-footer {
  padding: 20px;
  border-top: 1px solid #e5e5e5;
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.modal-overlay .rotation-controls {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.modal-overlay .action-controls {
  display: flex;
  justify-content: center;
  gap: 15px;
}

.modal-overlay .btn {
  padding: 10px 20px;
  border: none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  font-weight: 500;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.modal-overlay .btn-icon {
  padding: 12px;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-overlay .btn-primary {
  background: #007bff;
  color: white;
}

.modal-overlay .btn-primary:hover {
  background: #0056b3;
  transform: translateY(-1px);
}

.modal-overlay .btn-secondary {
  background: #6c757d;
  color: white;
}

.modal-overlay .btn-secondary:hover {
  background: #545b62;
  transform: translateY(-1px);
}

.modal-overlay .btn-icon.btn-secondary {
  background: #f8f9fa;
  color: #6c757d;
  border: 2px solid #e9ecef;
}

.modal-overlay .btn-icon.btn-secondary:hover {
  background: #e9ecef;
  color: #495057;
  border-color: #dee2e6;
}

.modal-overlay .rotation-icon {
  width: 20px;
  height: 20px;
  fill: currentColor;
}

.modal-overlay .btn-icon:hover .rotation-icon {
  transform: rotate(15deg);
  transition: transform 0.2s;
}

.modal-overlay .btn-icon:hover .rotate-left {
  transform: rotate(-15deg);
}
</style>
